export {OfficeSelector} from './OfficeSelector'
export type {SelectedOffice, ExtraItem} from './SelectedOffices'
export {ScalarOfficeSelector} from './ScalarOfficeSelector'

import {OFFICES_BY_IDS} from './query'
export const REFETCH_QUERIES_ON_UPDATE_OFFICE = [OFFICES_BY_IDS]
